import { env } from 'config/env'

export const IS_DEVELOPMENT =
  env.NODE_ENV === 'local' || env.NODE_ENV === 'development' || env.NEXT_PUBLIC_ENV !== 'production'
export const IS_PRODUCTION = env.NODE_ENV === 'production' && env.NEXT_PUBLIC_ENV === 'production'
